import { render, staticRenderFns } from "./choosecustom.vue?vue&type=template&id=522f4b4a&scoped=true"
import script from "./choosecustom.vue?vue&type=script&lang=js"
export * from "./choosecustom.vue?vue&type=script&lang=js"
import style0 from "./choosecustom.vue?vue&type=style&index=0&id=522f4b4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522f4b4a",
  null
  
)

export default component.exports